/** Downsample before Recharts. Keep first/last points; stride the middle. */
export function downsampleSeries(rows, maxPoints = 500) {
  if (!Array.isArray(rows) || rows.length <= maxPoints) return rows;
  const lastIdx = rows.length - 1;
  const out = [];
  const seen = new Set();
  for (let i = 0; i < maxPoints - 1; i += 1) {
    const idx = Math.round((i / (maxPoints - 1)) * lastIdx);
    if (seen.has(idx)) continue;
    seen.add(idx);
    out.push(rows[idx]);
  }
  if (!seen.has(lastIdx)) out.push(rows[lastIdx]);
  return out;
}
